import React from "react";
import { Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
// mantine
import {
  AppShell,
  Burger,
  Group,
  Space,
  Anchor,
  Text,
  NavLink,
  Stack,
  rem,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
// UI
import { MightierLogoSVG } from "@components/MightierLogoSvg";
import { IconChevronRight, IconExternalLink } from "@tabler/icons-react";
import cssClasses from "./members_layout.module.css";
import { staticLinks } from "@config/staticLinks";

import { backendApi } from "src/backendApi/backendApi";

import {
  TanstackMantineLink,
  TanstackMantineNavLink,
} from "@components/tanstack-mantine-link";

export const MembersLayout = React.memo(() => {
  const [opened, { toggle, close }] = useDisclosure();
  const { t } = useTranslation();

  const openModal = () =>
    modals.openConfirmModal({
      title: t("membersLayout.logOutModalTitle"),
      children: <Text>{t("membersLayout.logOutModalMessage")}</Text>,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: async () => {
        await backendApi.logout();
      },
    });

  return (
    <AppShell
      header={{ height: 83 }}
      navbar={{ width: 300, breakpoint: "sm", collapsed: { mobile: !opened } }}
      padding="md"
    >
      <AppShell.Header className={cssClasses.header}>
        <Group h="100%" px="lg" justify="space-between">
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
          <TanstackMantineLink
            to="/gs-admin/members"
            style={{ cursor: "pointer" }}
          >
            <MightierLogoSVG />
          </TanstackMantineLink>
          <Anchor onClick={openModal}>{t("membersLayout.logOut")}</Anchor>
        </Group>
      </AppShell.Header>
      <AppShell.Navbar bg="#012B60">
        <Space h={120} />

        <TanstackMantineNavLink
          to="/gs-admin/members/enroll"
          label={t("membersLayout.navBar.createAccount")}
          rightSection={<IconChevronRight />}
          className={cssClasses["my-nav-link"]}
        />

        <TanstackMantineNavLink
          to="/gs-admin/members/search"
          label={t("membersLayout.navBar.manageExisting")}
          rightSection={<IconChevronRight />}
          className={cssClasses["my-nav-link"]}
        />

        <NavLink
          href={staticLinks.howItWorks}
          onClick={close}
          target="_blank"
          rel="noopener noreferrer"
          label={t("membersLayout.navBar.howMightierWorks")}
          rightSection={<IconExternalLink />}
          className={cssClasses["my-nav-link"]}
        />

        <NavLink
          href={staticLinks.faqs}
          onClick={close}
          target="_blank"
          rel="noopener noreferrer"
          label={t("membersLayout.navBar.faqs")}
          rightSection={<IconExternalLink />}
          className={cssClasses["my-nav-link"]}
        />

        <NavLink
          href={staticLinks.contactPage}
          onClick={close}
          target="_blank"
          rel="noopener noreferrer"
          label={t("membersLayout.navBar.contactMightier")}
          rightSection={<IconExternalLink />}
          className={cssClasses["my-nav-link"]}
        />
      </AppShell.Navbar>
      <AppShell.Main>
        <Stack pt={rem(78)} px={rem(48)} pb={rem(48)}>
          <Outlet />
        </Stack>
      </AppShell.Main>
    </AppShell>
  );
});

MembersLayout.displayName = "MembersLayout";
